import React from 'react';
import { MainLayoutHeader, MainLayoutHeaderProps } from '@app/components';

export const ProductHeader = ({ children }: Pick<MainLayoutHeaderProps, 'children'>) => {
  return (
    <MainLayoutHeader
      tabs={[
        {
          label: 'Produits',
          screenName: 'ProductScreen',
          permissions: ['dashboard::products.read'],
        },
        {
          label: 'Variations',
          screenName: 'VariationScreen',
          permissions: ['dashboard::variations.read'],
        },
        {
          label: 'Ingrédients',
          screenName: 'IngredientScreen',
          permissions: ['dashboard::ingredients.read'],
        },
        {
          label: 'Ruptures',
          screenName: 'RuptureScreen',
          permissions: ['dashboard::ingredients.out-of-stock'],
        },
        {
          label: 'Options',
          screenName: 'OptionScreen',
          permissions: ['dashboard::options.read'],
        },
        {
          label: 'Catégories',
          screenName: 'TagScreen',
          permissions: ['dashboard::tags.read'],
        },
        {
          label: 'Codes comptables',
          screenName: 'AccountCodeScreen',
          permissions: ['dashboard::account-codes.read'],
        },
      ]}>
      {children}
    </MainLayoutHeader>
  );
};
